import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
import Truncate from "react-truncate"
class TableNotificacaoTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreSolicitacao(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  render() {
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar Notificações"
        >
          {this.props.rows.map((row, key) => {
            return (
              <div key={key} className="col-md-4">
                <div className="card">
                  <div
                    className="card-header"
                    data-background-color={this.props.backgroundColor}
                  >
                    <h4 className="title text-center col-md-offset-right-1">
                      {"Contrato Nº " + row.contrato.num_contrato}
                    </h4>
                    <p className="category text-center col-md-offset-right-1">
                      {"Criado em " + Moment(row.created_at).format("D/MM/Y")}
                    </p>
                  </div>
                  <div className="solicitacao-quote col-md-12">
                    <table className="table table-hover">
                      <thead className="text-warning">
                        <tr>
                          <th>Pendência</th>
                          <th>Referência</th>
                        </tr>
                      </thead>
                      <tbody>
                        {row.pendencias
                          .slice(0, 4)
                          .map((pendencia, pendenciaKey) => {
                            return (
                              <tr key={pendenciaKey}>
                                <td>
                                  <Truncate lines={1}>
                                    {pendencia.pendencia}
                                  </Truncate>
                                </td>
                                <td>
                                  <Truncate lines={1}>
                                    {pendencia.ref_contratual}
                                  </Truncate>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                    <div className="row">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Restaurar Notificação"
                        onClick={() => this.restore(row.id)}
                        className="col-md-12 btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableNotificacaoTrash)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/TableNotificacaoTrash.js